/* ==========================================================================
   norsu Interiors — Search Results page enhancer
   --------------------------------------------------------------------------
   For: Shopify "Testament" theme 15.3.0 + Shopify Search & Discovery.

   Pairs with search-page.css. Does the few things CSS can't:
     1) Tags the products grid + cards with stable hooks the CSS styles.
     2) Reorders the PRODUCTS block ABOVE the Articles block (products first).
     3) Injects a compact "143 results for “cushions”" header and tucks the
        Sort control into it; hides the theme's default "Search our store"
        title + restated-query sentence.
     4) Wires a front/back image cross-fade on hover.

   It is GATED to the search results page only and every step is wrapped in
   try/catch — if your theme nests something differently, that one step is
   skipped and the rest (and your search bar) keep working untouched.

   Load it once on the search page (see the install guide).
   ========================================================================== */
(function () {
  "use strict";

  // ---- Gate: only run on the search results page -------------------------
  var isSearch =
    document.body.classList.contains("template-search") ||
    /^\/search\b/.test(location.pathname);
  if (!isSearch) return;

  function run() {
    // The search page now uses the custom col-card grid + facets (main-search.liquid),
    // which is fully self-contained and renders its own results header + sort. This
    // legacy enhancer targeted the old stock Testament markup (.product-info); on the
    // new page it only conflicts — it grabs the filter form's hidden sort_by input and
    // hoists the whole form into a broken header. Bail when the custom grid is present.
    if (document.querySelector("#product-grid .col-card, .col-grid .col-card")) return;

    document.body.classList.add("nrs-search");

    var grid = tagProductsGrid();      // step 1
    if (grid) {
      tagCards(grid);                  // step 1
      wireHoverImages(grid);           // step 4
    }
    try { reorderProductsFirst(grid); } catch (e) {}   // step 2
    try { buildCompactHeader(grid); }  catch (e) {}    // step 3
    try { tagArticles(grid); }         catch (e) {}    // demote articles
  }

  /* ---- STEP 1a — find + tag the products grid -------------------------- */
  function tagProductsGrid() {
    try {
      // Testament search renders each product's text block as .product-info.
      var infos = document.querySelectorAll(".product-info");
      if (!infos.length) return null;

      // Climb each .product-info to its grid item, then read the common parent.
      var counts = new Map();
      var cards = [];
      infos.forEach(function (info) {
        var card =
          info.closest("li, .grid__item, .grid-item, [class*='grid__item'], [class*='grid-item']") ||
          info.parentElement;
        if (!card) return;
        cards.push(card);
        var p = card.parentElement;
        counts.set(p, (counts.get(p) || 0) + 1);
      });

      // The parent holding the most product cards is the grid.
      var grid = null, max = 0;
      counts.forEach(function (n, el) { if (n > max) { max = n; grid = el; } });
      if (!grid) return null;

      grid.classList.add("nrs-product-grid");
      window.__nrsCards = cards.filter(function (c) { return c.parentElement === grid; });
      return grid;
    } catch (e) { return null; }
  }

  /* ---- STEP 1b — tag each card + its media anchor ---------------------- */
  function tagCards(grid) {
    try {
      (window.__nrsCards || []).forEach(function (card) {
        card.classList.add("nrs-card");

        // Mark sold-out cards (so CSS can dim them).
        if (/sold\s*out/i.test(card.textContent || "")) card.classList.add("nrs-card--sold");

        // The media = the first link/figure that contains a product image.
        var media =
          card.querySelector("a:has(img), figure:has(img)") ||
          (function () {
            var img = card.querySelector("img");
            return img ? (img.closest("a, figure") || img.parentElement) : null;
          })();
        if (media) media.classList.add("nrs-card__media");
      });
    } catch (e) {}
  }

  /* ---- STEP 4 — front/back image cross-fade --------------------------- */
  function wireHoverImages(grid) {
    try {
      (window.__nrsCards || []).forEach(function (card) {
        var media = card.querySelector(".nrs-card__media") || card;
        var imgs = media.querySelectorAll("img");
        if (imgs.length >= 2) {
          imgs[0].classList.add("nrs-img--front");
          imgs[1].classList.add("nrs-img--back");
          // Nudge a lazy back-image to load so the swap isn't blank.
          var b = imgs[1];
          if (b.dataset && b.dataset.src && !b.src) b.src = b.dataset.src;
          if (b.dataset && b.dataset.srcset && !b.srcset) b.srcset = b.dataset.srcset;
        } else if (imgs.length === 1) {
          imgs[0].classList.add("nrs-img--front");
        }
      });
    } catch (e) {}
  }

  /* ---- STEP 2 — products above articles ------------------------------- */
  function reorderProductsFirst(grid) {
    if (!grid) return;
    var productsHeading = findHeading(/^\s*product/i);
    var articlesHeading = findHeading(/^\s*article/i);
    if (!articlesHeading) return; // nothing to move past

    // Resolve the two sibling "blocks" that share a parent.
    var pBlock = blockOf(productsHeading || grid);
    var aBlock = blockOf(articlesHeading);
    if (!pBlock || !aBlock) return;

    // Lift them to siblings under a common parent.
    while (pBlock.parentElement !== aBlock.parentElement) {
      if (pBlock.parentElement && pBlock.parentElement.contains(aBlock)) {
        aBlock = aBlock.parentElement;
      } else if (aBlock.parentElement && aBlock.parentElement.contains(pBlock)) {
        pBlock = pBlock.parentElement;
      } else if (pBlock.parentElement) {
        pBlock = pBlock.parentElement;
      } else break;
    }
    if (pBlock.parentElement && pBlock.parentElement === aBlock.parentElement) {
      // Only move if products currently come AFTER articles.
      if (aBlock.compareDocumentPosition(pBlock) & Node.DOCUMENT_POSITION_FOLLOWING) {
        aBlock.parentElement.insertBefore(pBlock, aBlock);
      }
    }
  }

  // The "block" for a heading = a wrapping section if present, else the
  // top-most ancestor that doesn't also contain the OTHER section's heading.
  function blockOf(node) {
    if (!node) return null;
    var sec = node.closest("section, .search-section, [class*='results']");
    return sec || node.parentElement || node;
  }

  function findHeading(re) {
    var hs = document.querySelectorAll("h1, h2, h3");
    for (var i = 0; i < hs.length; i++) {
      if (re.test((hs[i].textContent || "").trim())) return hs[i];
    }
    return null;
  }

  /* ---- STEP 3 — compact results header -------------------------------- */
  function buildCompactHeader(grid) {
    var params = new URLSearchParams(location.search);
    var q = (params.get("q") || "").trim();

    // Total count: prefer the document title ("143 results found for …").
    var count = null;
    var mTitle = (document.title || "").match(/([\d,]+)\s+results?/i);
    if (mTitle) count = mTitle[1];
    if (!count) {
      var body = document.body.textContent || "";
      var mBody = body.match(/of\s+([\d,]+)\s*\.?/i) || body.match(/([\d,]+)\s+results?/i);
      if (mBody) count = mBody[1];
    }

    // Hide the theme's default title + restated-query sentence (clutter).
    hideNativeTitle();

    // Build the compact header.
    var head = document.createElement("div");
    head.className = "nrs-results-head";

    var intro = document.createElement("div");
    intro.className = "nrs-results-head__intro";

    var eyebrow = document.createElement("span");
    eyebrow.className = "nrs-eyebrow";
    eyebrow.textContent = "Search results";

    var h1 = document.createElement("h1");
    h1.className = "nrs-results-head__count";
    var qHtml = q ? ' for <span class="nrs-q">\u201c' + escapeHtml(q) + '\u201d</span>' : "";
    if (count) {
      h1.innerHTML = escapeHtml(count) + " result" + (count === "1" ? "" : "s") + qHtml;
    } else if (q) {
      h1.innerHTML = "Results" + qHtml;
    } else {
      h1.textContent = "Search results";
    }

    intro.appendChild(eyebrow);
    intro.appendChild(h1);
    head.appendChild(intro);

    // Move the Sort control into the header (keep it fully functional).
    var sortEl = document.querySelector("select[name='sort_by'], #SortBy, [name='sort_by']");
    if (sortEl) {
      var sortWrap = sortEl.closest(".sort-by, .sort, .toolbar__sort, form") || sortEl.parentElement;
      var nrsSort = document.createElement("div");
      nrsSort.className = "nrs-sort";
      nrsSort.appendChild(sortWrap);
      head.appendChild(nrsSort);
    }

    // Insert the header just above the products.
    var anchor = grid || document.querySelector(".nrs-product-grid");
    var container = anchor ? anchor.parentElement : (document.querySelector("#main-content, main"));
    if (container) {
      if (anchor && anchor.parentElement === container) {
        container.insertBefore(head, blockTop(anchor, container));
      } else {
        container.insertBefore(head, container.firstChild);
      }
      var shell = container.closest(".page-width, .container, #main-content, main");
      if (shell) shell.classList.add("nrs-shell");
    }
  }

  // Walk up from node to the child of `container`, so we insert before the
  // whole products block (incl. its "Products" heading), not mid-way.
  function blockTop(node, container) {
    var n = node;
    while (n.parentElement && n.parentElement !== container) n = n.parentElement;
    // include a preceding "Products" heading if it's a sibling
    var prev = n.previousElementSibling;
    if (prev && /^\s*product/i.test(prev.textContent || "") && /^H[1-6]$/.test(prev.tagName)) {
      return prev;
    }
    return n;
  }

  function hideNativeTitle() {
    // Big page title (e.g. "Search our store").
    var hs = document.querySelectorAll("#main-content h1, main h1, .template-search h1");
    hs.forEach(function (h) {
      if (h.classList.contains("nrs-results-head__count")) return;
      if (/search/i.test(h.textContent || "")) h.classList.add("nrs-hide-native");
    });
    // Restated "Your search for … revealed the following" sentence.
    var nodes = document.querySelectorAll("#main-content p, main p, .template-search p, #main-content h2, main h2");
    nodes.forEach(function (n) {
      if (/revealed the following|your search for/i.test(n.textContent || "")) {
        n.classList.add("nrs-hide-native");
      }
    });
  }

  /* ---- Demote the Articles block -------------------------------------- */
  function tagArticles(grid) {
    var articlesHeading = findHeading(/^\s*article/i);
    if (!articlesHeading) return;
    var block = blockOf(articlesHeading);
    if (block) {
      block.classList.add("nrs-reading");
      articlesHeading.classList.add("nrs-reading__title");
      articlesHeading.textContent = "From the journal";
    }
  }

  /* ---- utils ---------------------------------------------------------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
